import axios from "axios";
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Breadcrumb, Col, Modal, Pagination, Row, Input, message} from "antd";
import { getUserListening } from '../apis/userListening';
import Footer from "../component/Footer";
import CardItem from '../component/CardItem';
import {useCookies} from "react-cookie";
import dayjsInstance from "../utils/dayjs";

export default function Lesson() {

    const {slug} = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalSpeakOpen, setIsModalSpeakOpen] = useState(false);
    const [dataLesson, setdataLesson] = useState([]);
    const [dataUserTopic, setDataUserTopic] = useState({});
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
    });
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(null); // fresh user data from API (vip_expire_at)

    // Learning goals (course-level numeric targets)
    const goalStorageKey = `lesson_goal_course_${slug}`;
    const [goalDays, setGoalDays] = useState(() => {
        try { const v = JSON.parse(localStorage.getItem(goalStorageKey)); return v?.days || 30; } catch { return 30; }
    });
    const [goalHours, setGoalHours] = useState(() => {
        try { const v = JSON.parse(localStorage.getItem(goalStorageKey)); return v?.hours || 30; } catch { return 30; }
    });
    const [editingGoals, setEditingGoals] = useState(false);

    // older free-form goals list (kept for compatibility)
    const [goals, setGoals] = useState(() => {
        try { return JSON.parse(localStorage.getItem(`learning_goals_${slug}`)) || []; } catch { return []; }
    });
    const [goalInput, setGoalInput] = useState('');
    const [editGoalIndex, setEditGoalIndex] = useState(null);
    const [editGoalValue, setEditGoalValue] = useState('');

    const [userListenings, setUserListenings] = useState([]);

    const saveGoal = () => {
        const trimmed = goalInput.trim();
        if (!trimmed) return;
        const next = [...goals, { text: trimmed, done: false }];
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
        setGoalInput('');
        message.success('Đã thêm mục tiêu!');
    };

    const saveCourseGoals = (days, hours) => {
        const obj = { days: Number(days || 0), hours: Number(hours || 0) };
        try {
            localStorage.setItem(goalStorageKey, JSON.stringify(obj));
            setGoalDays(obj.days); setGoalHours(obj.hours);
            message.success('Đã lưu mục tiêu cho khoá học');
        } catch (e) { console.error(e); message.error('Không thể lưu mục tiêu'); }
    };

    const toggleGoal = (i) => {
        const next = goals.map((g, idx) => idx === i ? { ...g, done: !g.done } : g);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
    };

    const deleteGoal = (i) => {
        const next = goals.filter((_, idx) => idx !== i);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
    };

    const startEditGoal = (i) => {
        setEditGoalIndex(i);
        setEditGoalValue(goals[i].text);
    };

    const saveEditGoal = () => {
        if (!editGoalValue.trim()) return;
        const next = goals.map((g, idx) => idx === editGoalIndex ? { ...g, text: editGoalValue.trim() } : g);
        setGoals(next);
        localStorage.setItem(goalStorageKey, JSON.stringify(next));
        setEditGoalIndex(null);
        setEditGoalValue('');
    };

    const lesson = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/lesson/getBySlugCourse/${slug}`, {params: pagination});
            setdataLesson(response?.data[0]);
            // console.log(response.data[0]);
        } catch (error) {
            console.error(error);
        }
    }

    const fetchUserInfo = async () => {
        if (!cookies?.user?.token) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/me`, {
                headers: {
                    'Authorization': `Bearer ${cookies?.user?.token}`
                }
            });
            setUserInfo(response.data);
        } catch (error) {
            console.error('Error fetching user info:', error);
        }
    };

    const userTopic = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/usertopic`, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies?.user?.token}`
                }
            });
            setDataUserTopic(response?.data[0]);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        lesson();
        if (cookies?.user) {
            userTopic();
            fetchUserInfo();
            // fetch user's listening history for per-lesson stats
            (async () => {
                try {
                    const list = await getUserListening(cookies?.user?.token);
                    setUserListenings(list || []);
                } catch (e) { console.error('Fetch listenings error', e); }
            })();
        }
    }, [slug, cookies?.user, pagination.page, pagination.pageSize]);

    return (
        <>
            <div className="min-h-screen bg-[#0a1628] py-8">
                <div className="max-w-screen-2xl mx-auto p-6">
                    <Breadcrumb
                        className="py-5 [&_.ant-breadcrumb-link]:text-blue-400 [&_.ant-breadcrumb-separator]:text-gray-500 [&_a]:text-blue-400 [&_a:hover]:text-white"
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: <a href="/topic">Topic</a>,
                            },
                            {
                                title: <span className="text-gray-300">{dataLesson?.title}</span>,
                            },
                        ]}
                    />

                    <div className="text-center mb-8">
                        <h1 className="text-4xl font-bold text-white">{dataLesson?.title}</h1>
                        <p className="text-sm text-gray-400 mt-2">Danh sách bài học — chọn Listening hoặc Speaking để bắt đầu</p>
                    </div>

                    {/* Learning Goals */}
                    <div className="mb-8 bg-[#1a2d4a] border border-white/10 rounded-2xl p-5">
                        <div className="flex items-center gap-2 mb-4">
                            <span className="text-xl">🎯</span>
                            <h2 className="text-white font-bold text-lg">Mục tiêu học tập</h2>
                            <div className="ml-auto text-right">
                                <p className="text-xs text-gray-400">Mục tiêu khóa</p>
                                <p className="text-white font-semibold">{goalDays} ngày · {goalHours} giờ</p>
                            </div>
                        </div>


                        {/* Course numeric goals editor */}
                        <div className="mb-4">
                            <div className="bg-[#0f1e35] rounded-xl p-3 border border-white/5">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-gray-400 text-xs">Mục tiêu (sửa được)</p>
                                        <p className="text-white font-bold text-sm">{goalDays} ngày · {goalHours} giờ</p>
                                    </div>
                                    <div>
                                        <button onClick={() => setEditingGoals(v => !v)} className="text-blue-300 hover:text-white">
                                            {editingGoals ? 'Huỷ' : 'Chỉnh'}
                                        </button>
                                    </div>
                                </div>

                                {editingGoals && (
                                    <div className="mt-3 flex gap-3 items-center">
                                        <input type="number" value={goalDays} onChange={e => setGoalDays(Number(e.target.value))}
                                            className="w-28 px-3 py-1 rounded bg-[#081226] text-white text-sm border border-white/10" />
                                        <span className="text-gray-400 text-sm">ngày</span>
                                        <input type="number" value={goalHours} onChange={e => setGoalHours(Number(e.target.value))}
                                            className="w-28 px-3 py-1 rounded bg-[#081226] text-white text-sm border border-white/10" />
                                        <span className="text-gray-400 text-sm">giờ</span>
                                        <button onClick={() => { saveCourseGoals(goalDays, goalHours); setEditingGoals(false); }}
                                            className="px-3 py-1 rounded bg-cyan-500 text-white text-sm">Lưu</button>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Add new goal */}
                        <div className="flex gap-2">
                            <Input
                                value={goalInput}
                                onChange={e => setGoalInput(e.target.value)}
                                onPressEnter={saveGoal}
                                placeholder="Thêm mục tiêu học tập mới… (ví dụ: Hoàn thành 5 bài tuần này)"
                                className="bg-[#0f1e35] border-white/20 text-white placeholder:text-gray-500 flex-1 rounded-xl"
                            />
                            <button
                                onClick={saveGoal}
                                className="px-4 py-2 rounded-xl bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold transition-colors shadow-lg shadow-blue-500/20 whitespace-nowrap"
                            >
                                + Thêm
                            </button>
                        </div>
                    </div>

                    <Row gutter={[16, 16]}>
                        {dataLesson?.lesson?.map((lesson, index) => {
                            const vipExpireAt = userInfo?.vip_expire_at || cookies?.user?.vip_expire_at;
                            const hasVipAccess = (dayjsInstance(vipExpireAt)?.format("YYYY-MM-DD") > dayjsInstance(Date())?.format("YYYY-MM-DD") && vipExpireAt !== null);
                            const hasProgressUnlock = +dataUserTopic?.lesson_id >= +lesson.id;
                            const isFirstLesson = +index === 0;
                            // If lesson is marked as FREE (0), always unlocked. If VIP (1), check access
                            const unlocked = lesson.is_vip !== 1 || hasVipAccess || hasProgressUnlock || isFirstLesson;
                            const sessionsCount = (userListenings || []).filter(u => +u.lesson_id === +lesson.id).length;
                            // compute streak values for this card
                            const lessonHoursDone = Math.round(((lesson.duration || 0) / 3600) * sessionsCount * 100) / 100;
                            return (
                                <Col xs={24} sm={12} md={8} xl={6} key={index}>
                                    <CardItem
                                        to={unlocked ? ("/lesson/listening/" + lesson?.slug) : undefined}
                                        linkState={{index: index}}
                                        title={lesson.title}
                                        subtitle={lesson.description || ''}
                                        image={lesson?.lesson_url}
                                        imageAlt={lesson.title}
                                        badge={lesson.is_vip === 1 ? 'VIP' : ''}
                                        isVipLocked={!unlocked}
                                        progress={0}
                                        buttonLabel={unlocked ? 'Học ngay' : 'Mở khóa'}
                                        disabled={!unlocked}
                                        onClick={() => { if(!unlocked) setIsModalOpen(true); }}
                                        noLink={true}
                                        meta={`⏱ ${lesson.duration || '—'} · Thực tế: ${sessionsCount}/${goalDays}`}
                                        streakDaysDone={sessionsCount}
                                        streakDaysGoal={goalDays}
                                        streakHoursDone={lessonHoursDone}
                                        streakHoursGoal={goalHours}
                                        streakSessions={sessionsCount}
                                        actions={(
                                            <div className='flex items-center gap-2 flex-wrap'>
                                                {unlocked ? (
                                                    <Link
                                                        to={"/lesson/listening/" + lesson?.slug}
                                                        state={{index: index}}
                                                        className='w-full'
                                                        onClick={e => e.stopPropagation()}
                                                    >
                                                        <span className='flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl bg-blue-500 text-white hover:bg-blue-600 transition-all w-full shadow-lg shadow-blue-500/20'>
                                                            🎧 Học ngay
                                                        </span>
                                                    </Link>
                                                ) : (
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); setIsModalOpen(true); }}
                                                        className='w-full flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl bg-white/5 text-gray-500 border border-white/10 cursor-not-allowed whitespace-nowrap'
                                                    >
                                                        � Mở khóa
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            )
                        })}
                    </Row>

                    <Pagination
                        className="flex justify-center pt-[30px]"
                        current={pagination.page}
                        total={dataLesson?.total}
                        pageSize={pagination.pageSize}
                        onChange={(p, ps) => {
                            setPagination({
                                page: p,
                                pageSize: ps
                            })
                        }}
                    />

                </div>
            </div>
                
            {Footer()}

            <Modal open={isModalOpen}
                   onOk={() => cookies?.user ? navigate(`/profile/${cookies.user.id}`) : navigate('/login')}
                   onCancel={() => setIsModalOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-2 pt-8">Vui lòng truy cập vào profile và </p>
                <p className="text-xl font-bold py-2 pb-8">đăng ký gói vip để được sử dụng dịch vụ này</p>
            </Modal>

            <Modal open={isModalSpeakOpen} onOk={() => setIsModalSpeakOpen(false)}
                   onCancel={() => setIsModalSpeakOpen(false)} okButtonProps={{className: "bg-blue-500"}}>
                <p className="text-xl font-bold py-5 pt-8">Vui lòng tải app để được dùng chức năng này!</p>
            </Modal>
        </>
    );
};
